<template>
  <div class="housing-estate-detail-warp">
    <div class="housing-system-header">
      <div class="housing-system-left">{{`${orgName}—${projectName}`}}</div>
      <div class="housing-system-right">
        <!-- <div class="system-left">{{projectName}}</div> -->
        <p class="time-count">
          <span class="time-count-title">登录倒计时：</span>
          <span class="time-count-number">{{minutes > 9 ? minutes : '0' + minutes}}</span>分
          <span class="time-count-number">{{seconds > 9 ? seconds : '0' + seconds}}</span>秒
        </p>
        <div class="system-right" @click="goBack">退出个人查询</div>
        <div class="system-right" @click="goNew">返回小区列表</div>
      </div>
    </div>
    <div class="housing-estate-detail-content" :class="pageType==='1'?'active':''">
      <el-tabs v-model="pageType">
        <el-tab-pane lazy label="房源公示" name="1">
          <section class="pane-content">
            <!-- 使用组件 housingResource 页面  -->
            <housingResource @change="handleChange" @add="handleAdd" @addTableHouseNum="addTableHouseNum" @getData="getData" ref="housingResource" @getList="getList" :isOverflow="isOverflow" :selectedLength="selectedLength" :optionalResettlementTotalArea="householdData.optionalResettlementTotalArea" :selectedArea="selectedArea" :houseId="houseId" :house="house" :houseIdItem="houseIdItem" :selectHouseMaxCount="householdData.selectHouseMaxCount" :selectedData="selectedData" :totalhouseTypeList="totalhouseTypeList" :householdTableData="householdTableData" :selectionHouseLimit="selectionHouseLimit"></housingResource>
          </section>
        </el-tab-pane>
        <el-tab-pane lazy label="小区介绍" name="2">
          <section class="pane-content">
            <estateIntroduce></estateIntroduce>
          </section>
        </el-tab-pane>
        <el-tab-pane lazy label="户型介绍" name="3" v-if="houseIntroduceList.length">
          <section class="pane-content">
            <imagesShow :page-size="3" :list="houseIntroduceList"></imagesShow>
          </section>
        </el-tab-pane>
        <el-tab-pane lazy label="效果图" name="4" v-if="effectImagesList.length">
          <section class="pane-content">
            <imagesShow :list="effectImagesList"></imagesShow>
          </section>
        </el-tab-pane>
        <el-tab-pane lazy label="规划图" name="5" v-if="planImagesList.length">
          <section class="pane-content">
            <imagesShow :list="planImagesList"></imagesShow>
          </section>
        </el-tab-pane>
        <el-tab-pane lazy label="实景图" name="6" v-if="liveActiveImagesList.length">
          <section class="pane-content">
            <imagesShow :list="liveActiveImagesList"></imagesShow>
          </section>
        </el-tab-pane>
        <el-tab-pane lazy label="配套类" name="7" v-if="environmentImagesList.length">
          <section class="pane-content">
            <imagesShow :list="environmentImagesList"></imagesShow>
          </section>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="test" v-show="pageType === '1'">
      <div class="test-top" style="border-bottom: 1px solid rgba(204, 204, 204, 1);">
        <div class="test-top-content">
          <div class="test-top-two-str">
            <span>当前产权人：</span>
            <span :title="householdData.propertyOwner">{{propertyOwner}}</span>
          </div>
          <div class="test-top-two-str">
            <span>档案号：</span>
            <span>{{householdData.householdCode}}</span>
          </div>
          <div class="test-top-two-str" v-if="this.householdData.selectHouseType!=5&&this.householdData.optionalResettlementTotalArea!='99999'&&(this.householdData.selectHouseType!=1||this.householdData.selectHouseType!=4)">
            <span>可选安置房总面积：</span>
            <span>{{householdData.optionalResettlementTotalArea}}㎡</span>
          </div>
          <div class="test-top-two-str" v-if="this.householdData.selectHouseType!=5">
            <span>安置补偿面积：</span>
            <span>{{householdData.resettlementCompensationArea}}㎡</span>
          </div>
          <!-- <div class="test-top-two-str" v-if="isSelectHouse&&this.householdData.optionalResettlementTotalArea!='99999'&&this.householdData.selectHouseType!=5">
            <span>超出安置补偿面积：</span>
            <span style="color:red">{{overflowArea}}㎡</span>
          </div> -->
          <div class="text-top-table" v-if="this.householdData.selectHouseType===1 || this.householdData.selectHouseType===4">
            <el-table size="mini" stripe border :data="householdTableData" max-height="120" :row-style="{height:'20px'}" :cell-style="{padding:'0px'}" :header-cell-style="{background:'#F5F7FA',color:'#606266', height:'10px', padding:'0px'}" style="width: 100%;">
              <el-table-column prop="taoTypeName" label="套型" align="center"></el-table-column>
              <el-table-column prop="selectNum" label="已选套数" align="center"></el-table-column>
              <el-table-column prop="selectHouseNum" label="已选房源数" align="center"></el-table-column>
            </el-table>
          </div>
          <div class="text-top-table" v-if="this.householdData.selectHouseType==5">
            <el-table size="mini" border :data="householdTableData" max-height="120" :row-style="{height:'20px'}" :cell-style="{padding:'0px'}" :header-cell-style="{background:'#ffffff',color:'#606266', height:'20px', padding:'0px'}" style="width: 100%;">
              <el-table-column prop="typeName" label="类型" align="center" width="60">
              </el-table-column>
              <el-table-column prop="resettlementNum" label="安置面积" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.resettlementNum}}㎡</span>
                </template>
              </el-table-column>
              <el-table-column prop="selectHouseNum" label="已选面积" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.selectHouseNum}}㎡</span>
                </template>
              </el-table-column>
              <el-table-column prop="residualArea" label="剩余面积" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.residualArea}}㎡</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="test-top-btn" @click="handleConfirm" v-if="isSelectHouse">提交选房</div>
        </div>
      </div>
      <div :class="bottomBindClass" v-if="isSelectHouse">
        <div class="test-top" v-for="item in selectedData" :key="item.id">
          <div class="test-top-content">
            <div class="test-top-two">
              <span>小区：</span>
              <span>{{item.housingEstateName}}</span>
            </div>
            <div class="test-top-two">
              <el-row :gutter="5">
                <el-col :span="12">楼栋：{{item.buildingName}}</el-col>
                <el-col :span="12">单元：{{item.unitName}}</el-col>
              </el-row>
            </div>
            <div class="test-top-two">
              <el-row :gutter="5">
                <el-col :span="12">房号：{{item.houseNumber}}</el-col>
                <el-col :span="12">面积：{{item.buildingArea}}㎡</el-col>
              </el-row>
            </div>
            <div class="test-top-two">
              <el-row :gutter="5">
                <el-col :span="12">户型：{{item.houseTypeName}}</el-col>
                <el-col :span="12" v-if="item.innerArea !== null">套内面积：{{item.innerArea}}㎡</el-col>
              </el-row>
            </div>
            <div class="test-top-two">
              <el-row :gutter="5">
                <el-col :span="12">居室：{{item.howBedroom}}</el-col>
                <el-col :span="12" v-if="item.sharedArea !== null">公摊面积：{{item.sharedArea}}㎡</el-col>
              </el-row>
            </div>

            <div class="test-top-btn" style="background-color: rgba(204, 102, 51, 1);" @click="handleRemove(item)" v-if="item.removable === '1'">移除该房</div>
          </div>
        </div>
      </div>
      <div :class="bottomNoneClass" v-else>
        <div style="height: 50px;"></div>
        <img src="../../../assets/img/u143.svg" alt style="width:100px;height:100px;display:block;margin-left:110px;margin-bottom: 30px;" />
        <p class="un-select-house-p">您可能未签约或选择已选择货币补偿</p>
        <p class="un-select-house-p">或未开启在线选房</p>
        <p class="un-select-house-p">如有疑问请和工作人员联系</p>
      </div>
      <div class="btn-refresh" @click="refresh">刷新</div>
    </div>
  </div>
</template>

<script type='text/babel'>
import Nav from '@/components/nav.vue';
import housingResource from './components/housingResource';
import estateIntroduce from './components/estateIntroduce';
import imagesShow from './components/imagesShow';
import {
  getHousingHouseTypeAndAttachmentList,
  getEstateAttachmetsTypeList,
  logoutHouseholdIndex,
  queryHouseholdHouseTaoTypeAndSelectHouseNumList
} from '@/api/publicinquiry.api.js';
import { setSession, getSession, decodeURI, removeSession, isUndef } from '@/untils';
import Cookies from 'js-cookie';
import { addition, subtract } from '@/untils/math';
export default {
  name: 'housing-estate-detail',
  computed: {
    bottomBindClass() {
      if (this.householdTableData.length == 1) {
        return 'test-bottom test-bottom1';
      } else if (this.householdTableData.length == 2) {
        return 'test-bottom test-bottom2';
      } else if (this.householdTableData.length >= 3 && this.householdData.selectHouseType !== 5) {
        return 'test-bottom test-bottom3';
      } else if (this.householdTableData.length == 0) {
        if (this.householdData.selectHouseType === 1 || this.householdData.selectHouseType === 4) {
          return 'test-bottom test-bottom4';
        } else {
          if (this.householdData.optionalResettlementTotalArea === 99999) {
            return 'test-bottom test-bottom5'
          }
        }
      }
      if (this.householdData.selectHouseType === 5) return 'test-bottom test-bottom6';
      return 'test-bottom';
    },
    bottomNoneClass() {
      if (this.householdTableData.length == 1) {
        return 'test-bottom-none test-none-bottom1';
      } else if (this.householdTableData.length == 2) {
        return 'test-bottom-none test-none-bottom2';
      } else if (this.householdTableData.length >= 3 && this.householdData.selectHouseType !== 5) {
        return 'test-bottom-none test-none-bottom3';
      } else if (this.householdTableData.length == 0) {
        if (this.householdData.selectHouseType === 1 || this.householdData.selectHouseType === 4) {
          return 'test-bottom-none test-none-bottom4';
        } else {
          if (this.householdData.optionalResettlementTotalArea === 99999) {
            return 'test-bottom-none test-none-bottom5'
          }
        }
      }
      if (this.householdData.selectHouseType === 5) return 'test-bottom-none test-none-bottom6';
      return 'test-bottom-none';
    },
    isSelectHouse() {
      return this.householdData.isSelectHouse === 1;
    },
    selectedArea() {
      const total = this.selectedData.reduce((pre, cur) => {
        const cba = cur.buildingArea || 0;
        return addition(pre, cba);
      }, 0);
      return total;
    },
    overflowArea() {
      if (Number(this.selectedArea) > Number(this.householdData.resettlementCompensationArea)) {
        return subtract(this.selectedArea, this.householdData.resettlementCompensationArea);
      } else {
        return 0;
      };
    },
    isOverflow() {
      return subtract(this.selectedArea, this.householdData.optionalResettlementTotalArea) >= 0;
    },
    selectedData() {
      const arr = [...this.houseList, ...this.selectedList];
      return arr;
    },
    selectedLength() {
      return this.selectedData.length;
    },
    propertyOwner() {
      if (this.householdData.propertyOwner) {
        return this.householdData.propertyOwner.length > 10 ? this.householdData.propertyOwner.substring(0, 10) + '...' : this.householdData.propertyOwner;
      } else {
        return this.householdData.propertyOwner;
      }
    }
  },
  data() {
    const { query } = this.$route;
    return {
      selectedList: [],
      query,
      pageType: '1',
      firstLoadPage: false,
      houseIntroduceList: [],
      houseList: [],
      effectImagesList: [],
      planImagesList: [],
      liveActiveImagesList: [],
      environmentImagesList: [],
      projectId: '',
      backName: '返回选房列表',
      backPath: 'selectionDetail',
      orgName: '',
      projectName: '',
      houseId: '',
      house: {},
      houseIdItem: '',
      householdData: {
        address: '',
        certificateNumber: '',
        householdCode: '',
        householdId: '',
        isSelectHouse: 1,
        selectHouseMaxCount: '',
        phone: '',
        projectId: '',
        propertyOwner: '',
        resettlementCompensationArea: 0,
        optionalResettlementTotalArea: 0,
        verifyCode: ''
      },
      totalhouseTypeList: [],
      householdTableData: [
        {
          typeName: '多层',
          resettlementNum: '',
          selectHouseNum: '',
          residualArea: ''
        },
        {
          typeName: '高层',
          resettlementNum: '',
          selectHouseNum: '',
          residualArea: ''
        },
        {
          typeName: '储藏室',
          resettlementNum: '15',
          selectHouseNum: '',
          residualArea: ''
        }
      ],
      contentStyleObj: {
        height: ''
      },
      time: null, // 定时器
      minutes: 10, // 分
      seconds: 0, // 秒
      selectionHouseLimit: '0'
    };
  },
  created() {
    this.selectionHouseLimit = this.$route.query.selectionHouseLimit;
    const list = getSession('houseList');
    this.houseList = !isUndef(list) && list.length > 0 ? list : [];
    this.orgName = getSession('newOrgName');
    this.projectName = getSession('projectName');
    this.projectId = getSession('projectId');
    if (this.query.pageType) {
      this.$set(this, 'pageType', this.query.pageType);
      this.$nextTick(() => {
        this.firstLoadPage = true;
      });
    } else {
      this.firstLoadPage = true;
    }
    this.getHousingHouseTypeAndAttachmentList();
    this.getEstateAttachmetsTypeList();
  },
  mounted() {
    this.countTime()
  },
  beforeDestroy() {
    this.$store.commit('setHouseList', []);

    // 销毁定时器
    window.clearInterval(this.time)
  },
  methods: {
    // 倒计时
    timeNum(n) {
      return n < 10 ? '0' + n : '' + n
    },
    countTime() {
      var _this = this
      this.time = window.setInterval(function () {
        if (_this.seconds === 0 && _this.minutes !== 0) {
          _this.seconds = 59
          _this.minutes -= 1
        } else if (_this.minutes === 0 && _this.seconds === 0) {
          _this.seconds = 0
          window.clearInterval(this.time)
        } else {
          _this.seconds -= 1
        }
      }, 1000)
    },

    addTableHouseNum(data) {
      // debugger;
      this.householdTableData = data;
    },
    getData(data) {
      this.householdData = data;
      if (this.householdData.selectHouseType === 1 || this.householdData.selectHouseType === 4) {
        this.queryHouseholdHouseTaoTypeAndSelectHouseNumList({ householdId: this.householdData.householdId, projectId: this.projectId });
      }
    },
    handleRemove(itemId) {
      // console.log(this.houseList);
      this.houseId = itemId.id;
      this.house = itemId;
      this.houseIdItem = itemId.orgTaoTypeId;
      this.houseList = this.houseList.filter(item => item.id !== itemId.id);
      // console.log(this.houseList, 'lllllll');
      this.$store.commit('setHouseList', this.houseList);
      this.$nextTick(() => {
        this.$refs.housingResource.removeHouse();
      });
    },
    refresh() {
      this.$refs.housingResource.queryHouseholdIndex();
    },
    handleConfirm() {
      this.$refs.housingResource.handleChoose();
    },
    handleAdd(data) {
      this.houseList.unshift(data);
      this.$store.commit('setHouseList', this.houseList);
    },
    handleChange() {
      this.houseList = [];
      this.selectedList = [];
      this.$store.commit('setHouseList', this.houseList);
    },
    queryHouseholdHouseTaoTypeAndSelectHouseNumList(params) {
      queryHouseholdHouseTaoTypeAndSelectHouseNumList(params).then(res => {
        if (res.code === 0) {
          this.householdTableData = res.body;
        }
      })
    },
    getHousingHouseTypeAndAttachmentList() {
      getHousingHouseTypeAndAttachmentList(this.projectId, this.query.id).then(
        res => {
          if (res.code === 0) {
            console.log(res.body);
            this.totalhouseTypeList = res.body
            const data = res.body;
            this.houseIntroduceList.splice(0, this.houseIntroduceList.length);
            data.forEach(item => {
              const {
                id,
                houseType,
                buildingArea,
                howBedroom,
                typeAttachmentList
              } = item;
              const exist = typeAttachmentList && typeAttachmentList[0];
              const imgUrl =
                exist &&
                decodeURI(
                  `/housing/source/downloadHousingHouseTypeAttachment/${exist.id}/0`
                );
              const littleImg = imgUrl || require('@/assets/img/noPhoto.jpeg');
              const path = imgUrl || require('@/assets/img/noPhoto_large.jpeg');
              this.houseIntroduceList.push({
                id,
                houseTypePanoramaUrl: item.houseTypePanoramaUrl,
                info: {
                  houseType,
                  buildingArea,
                  howBedroom
                },
                url: {
                  littleImg: littleImg,
                  path: path
                }
              });
            });
          } else {
            this.$message({
              message: res.errMsg,
              type: 'warning'
            });
          }
        }
      );
    },
    getEstateAttachmetsTypeList() {
      getEstateAttachmetsTypeList({ estatdId: this.query.id }).then(res => {
        if (res.code === 0) {
          const data = res.body;
          const allImagesList = [
            { list: 'effectImagesList', name: '效果图' },
            { list: 'planImagesList', name: '规划图' },
            { list: 'liveActiveImagesList', name: '实景图' },
            { list: 'environmentImagesList', name: '配套类' }
          ];
          allImagesList.forEach(f => {
            const { list, name } = f;
            const onlineList = data.filter(d => d.name === name)[0]
              .estateAttachmentList;
            this[list].splice(0, this[list].length);
            onlineList.forEach(item => {
              const imgUrl = decodeURI(
                `/housing/source/estatephoto/download/${item.id}/0`
              );
              const littleImg = imgUrl || require('@/assets/img/noPhoto.jpeg');
              const path = imgUrl || require('@/assets/img/noPhoto_large.jpeg');
              this[list].push({
                id: item.id,
                houseTypePanoramaUrl: item.houseTypePanoramaUrl,
                url: {
                  littleImg: littleImg,
                  path: path
                }
              });
            });
          });
        } else {
          this.$message({
            message: res.errMsg,
            type: 'warning'
          });
        }
      });
    },
    goBack() {
      this.$confirm('确定要退出个人查询么?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          logoutHouseholdIndex(this.projectId).then(res => {
            if (res.code === 0) {
              removeSession('token');
              removeSession('session');
              removeSession('selectFlag');
              removeSession('tierBuildingHouseIds');
              removeSession('highBuildingHouseIds');
              removeSession('userInfo');
              Cookies.remove('token');
              Cookies.remove('yz_session_id');
              this.$store.commit('setHouseList', []);
              this.$router.push({ path: '/selection' });
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    goNew() {
      removeSession('selectFlag');
      removeSession('tierBuildingHouseIds');
      removeSession('highBuildingHouseIds');
      this.$store.commit('setHouseList', []);
      this.$router.push({ path: '/selectionDetail' });
    },
    getList(data) {
      this.selectedList = data;
    },

    // 倒计时
    countDown() {
    }
  },
  watch: {
    pageType: {
      handler(val, oldVal) {
        if (val !== oldVal && this.firstLoadPage) {
          const { query } = this.$route;
          const copyQuery = JSON.parse(JSON.stringify(query));
          copyQuery.pageType = this.pageType;
          this.$router.replace({
            path: 'housingEstateDetail',
            query: copyQuery
          });
        }
      }
    },
    // 时分
    second: {
      handler (newVal) {
        this.timeNum(newVal)
      }
    },
    minute: {
      handler (newVal) {
        this.timeNum(newVal)
      }
    }
  },
  components: {
    Nav,
    housingResource,
    estateIntroduce,
    imagesShow
  }
};
</script>
<style scoped lang="less">
.housing-estate-detail-warp {
  position: relative;
  background: #fff;
  height: 100%;
  width: 100%;
  // display: flex;
  // flex-direction: column;
  .test {
    position: absolute;
    right: 10px;
    width: 321px;
    height: calc(~"100% - 65px");
    border-width: 1px;
    border-style: solid;
    border-color: rgba(204, 204, 204, 1);
    top: 50px;
    .test-top {
      // height: 150px;
      padding: 5px 10px;
      .test-top-content {
        width: 100%;
        height: 100%;
        padding-bottom: 10px;
        background-color: rgba(242, 242, 242, 1);
        .test-top-two {
          padding: 10px 0;
          padding-left: 5px;
          font-size: 14px;
        }
        .test-top-two-str {
          padding: 5px 0;
          padding-left: 5px;
          font-size: 14px;
        }
        .test-top-btn {
          width: 120px;
          height: 30px;
          background-color: rgba(2, 91, 145, 1);
          font-size: 14px;
          color: #ffffff;
          border-radius: 5px;
          text-align: center;
          cursor: pointer;
          line-height: 30px;
          margin: auto;
          &:hover {
            background: rgb(53, 124, 167);
          }
        }
        .text-top-table {
          width: 100%;
        }
      }
    }
    .test-bottom-none {
      overflow: auto;
      height: calc(~"100% - 200px");
      margin-bottom: 10px;
      .un-select-house-p {
        font-size: 14px;
        text-align: center;
        color: #999999;
        line-height: 35px;
      }
    }
    .test-bottom {
      overflow: auto;
      height: calc(~"100% - 245px");
      margin-bottom: 10px;
      .un-select-house-p {
        font-size: 14px;
        text-align: center;
        color: #999999;
        line-height: 35px;
      }
    }
    .test-bottom1 {
      height: calc(~"100% - 295px");
    }
    .test-bottom2 {
      height: calc(~"100% - 315px");
    }
    .test-bottom3 {
      height: calc(~"100% - 335px");
    }
    .test-bottom4 {
      height: calc(~"100% - 320px");
    }
    .test-bottom5 {
      height: calc(~"100% - 200px");
    }

    .test-bottom6 {
      height: calc(~"100% - 270px");
    }
    //未选房
    .test-none-bottom1 {
      height: calc(~"100% - 295px");
    }
    .test-none-bottom2 {
      height: calc(~"100% - 315px");
    }
    .test-none-bottom3 {
      height: calc(~"100% - 335px");
    }
    .test-none-bottom4 {
      height: calc(~"100% - 270px");
    }
    .test-none-bottom5 {
      height: calc(~"100% - 200px");
    }
    .test-none-bottom6 {
      height: calc(~"100% - 270px");
    }
    .btn-refresh {
      width: 120px;
      height: 30px;
      background-color: rgba(2, 91, 145, 1);
      font-size: 14px;
      color: #ffffff;
      border-radius: 5px;
      text-align: center;
      cursor: pointer;
      line-height: 30px;
      margin: auto;
      &:hover {
        background: rgb(53, 124, 167);
      }
    }
  }
  .housing-system-header {
    height: 40px;
    border-bottom: 1px solid rgb(2, 91, 145);
  }
  .housing-system-left {
    float: left;
    padding: 5px 0;
    text-indent: 15px;
    color: #025b91;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
  }
  .housing-system-right {
    float: right;
    display: flex;

    .time-count{
      padding: 5px 25px;

      .time-count-title{
        color: #025b91;
        font-weight: 700;
        font-size: 18px;
      }
      .time-count-number{
        padding: 5px;
        background-color: #ff9900;
        color: #fff;
        font-weight: bold;
        margin-right: 5px;
      }
    }
  }
  .system-left {
    // margin-right: 224px;
    padding: 5px 150px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    color: #1e1e1e;
  }
  .system-right {
    margin-right: 15px;
    line-height: 30px;
    text-align: center;
    width: 100px;
    height: 30px;
    background: inherit;
    background-color: rgba(2, 91, 145, 1);
    border: none;
    border-top: 0px;
    border-radius: 10px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
  }
  .housing-estate-detail-content {
    // flex: 1;
    overflow: hidden;
    padding: 10px 30px;
    height: calc(~"100% - 40px");
    // padding-left: 50px;
    // width: 80%;
    /deep/ .el-tabs {
      width: 100%;
      height: 100%;
      // display: flex;
      // flex-direction: column;
      .el-tabs__header {
        margin-bottom: 0;
      }
      .el-tabs__content {
        // flex: 1;
        border: 1px solid #e4e7ed;
        overflow: hidden;
        height: calc(~"100% - 40px");
        .el-tab-pane {
          width: 100%;
          height: 100%;
          .pane-content {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .active {
    width: calc(~"100% - 321px");
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/project-system/selection/housing-estate-detail.vue